import Box from '@mui/material/Box';
import CloseButton from '../../../components/Button/CloseButton';
import UploadButton from '../../../components/Button/UploadButton';
import SectionAppBar from '../../../components/Section/SectionAppBar';
import AccountImportFieldMapping from './AccountImportFieldMapping';
import SheetErrors from './SheetErrors';
import useAccountImport from './hooks/AccountImport.hooks';

const AccountImportStepOne = () => {
    const { open, onClose, onFileUpload, errors, hasError, hasWarning } = useAccountImport();

    return (
        <>
            <SectionAppBar
                title="Import Accounts"
                subTitle=""
                buttons={
                    <>
                        <CloseButton onClick={onClose}>Close</CloseButton>
                    </>
                }
            />
            <Box padding={2}>
                <UploadButton id="excel-upload-button" onUpload={onFileUpload}>
                    Upload
                </UploadButton>

                {errors.length > 0 && <SheetErrors errors={errors} hasError={hasError} hasWarning={hasWarning} />}

                {errors.length === 0 && <AccountImportFieldMapping />}
            </Box>
        </>
    );
};

export default AccountImportStepOne;
